import SwitchView from './SwitchView';

export default SwitchView;
